<template>
  <div :class="[{ open: isMenuOpen }, 'menu']" :style="menuDynmicStyle">
    <div class="actionsBar">
      <div>
        <button type="button" @click="menuBtnClick()">
          <i class="iconfont icon-hanbaocaidan"></i>
        </button>
        <h3></h3>
        <h3 :class="[{ open1: isMenuOpen }, 'menuText']">LimitYang</h3>
      </div>
    </div>
    <ul class="optionsBar">
      <li class="menuItem">
        <button href="/nwcpnl" class="menuOption">
          <i class="el-icon-s-home iconfont"></i>
          <h5 :class="[{ open2: isMenuOpen }, 'menuText']">主页</h5>
        </button>
      </li>
      <li class="menuBreak"><hr /></li>
      <li v-for="(item, index) in menuItems" :key="index" class="menuItem">
        <button type="button" class="menuOption">
          <i :class="['iconfont', item.iconClass]"></i>
          <h5 :class="[{ open2: isMenuOpen }, 'menuText']">{{ item.content }}</h5>
        </button>
      </li>
    </ul>
    <!-- <div class="about" id="about"></div> -->
    <div class="menuUser">
      <a href="#">
        <div>
          <img src="./LOGO.png" alt="" />
        </div>
        <h5 class="Username menuText">山羊</h5>
        <p class="menuText"><i class="iconfont icon-youjiantou"></i></p>
      </a>
    </div>
    <div class="themeBar">
      <div>
        <button type="button"><i class="iconfont el-icon-bottom-left"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SideBar',
  computed: {
    ...mapState(['browserScale']),
    menuDynmicStyle() {
      const menuHeight = 61.6
      const calculatedHeight = (this.viewportHeight - menuHeight) * 0.9
      const calculatedTop = (this.viewportHeight - menuHeight) * 0.05 + menuHeight
      return {
        height: `${calculatedHeight}px`,
        top: `${calculatedTop}px`
      }
    }
  },
  data() {
    return {
      isMenuOpen: false,
      menuItems: [
        { content: '名片', iconClass: 'el-icon-postcard' },
        { content: '相册', iconClass: 'el-icon-picture' }
      ],
      viewportHeight: window.innerHeight
    }
  },
  watch: {
    // 监听browserScale的变化（如果它是响应式的）
    browserScale(newVal) {
      // 这里可以添加逻辑来处理browserScale变化时的情况
      // 但由于viewportHeight不是响应式的，所以这里不会触发menuDynmicStyle的重新计算
    }
    // 注意：我们不能直接监听viewportHeight，因为它不是组件的数据属性
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  updated() {},
  methods: {
    handleResize() {
      this.viewportHeight = window.innerHeight
    },
    menuBtnClick() {
      this.toggleMenu()
      this.animateMenuText()
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    animateMenuText() {
      this.menuText.forEach((text, index) => {
        setTimeout(() => {
          text.isOpen = !text.isOpen
        }, index * 50)
      })
    }
  }
}
</script>

<style scoped>
@import './font/iconfont.css';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow: auto;
  background-color: #d1d4dc;
}

.iconfont {
  font-size: 22.92px;
}

.menu {
  position: fixed;
  width: 60px;
  height: calc((100vh - 61.6px) * 0.9);
  background-color: rgb(0, 37, 60, 0.9);
  z-index: 0;
  top: calc(5vh + 64.68px);
  /* bottom: 0; */
  /* left: 10px; */
  margin: auto;
  border-radius: 0.8rem;
  transition: 0.3s ease 0.15s;
  font-family: sans-serif;
  overflow: hidden;
}

.menu a {
  text-decoration: none;
}

.menu .actionsBar {
  width: 100%;
  height: 10%;
  padding: 0.5rem;
  overflow: hidden;
}

.menu .actionsBar div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.5rem;
  transition: 0.3s ease;
}

.menu .actionsBar div button {
  background-color: transparent;
  outline: none;
  border: none;
  border-radius: 0.5rem;
  color: #8a7ae8;
  width: 45px;
  height: 45px;
  transition: 0.3s ease;
  font-size: 1rem;
}

.menu .actionsBar div button:hover {
  background-color: #302e80;
  color: #f19fa3;
}

.menu .actionsBar div h3 {
  width: calc(100% - 45px);
  text-align: center;
}

.menu .optionsBar {
  overflow: hidden;
  display: flex;
  width: 100%;
  height: 60%;
  padding: 0 0.5rem;
  align-items: center;
  flex-direction: column;
}

.menu .optionsBar .menuItem {
  width: 100%;
  height: 45px;
  margin: 0.3rem;
}

.menu .optionsBar .menuItem .menuOption {
  font-size: 1rem;
  outline: none;
  border: none;
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.5rem;
  transition: 0.3s ease;
}

.menu .optionsBar .menuItem .menuOption:hover {
  background-color: #4236c7;
  color: #f19fa3;
}
.menu .optionsBar .menuItem .menuOption:hover i,
.menu .optionsBar .menuItem .menuOption:hover h5 {
  color: #f19fa3;
}
.menu .optionsBar .menuItem .menuOption i {
  width: 45px;
  text-align: center;
  color: #8a7ae8;
}

.menu .optionsBar .menuItem .menuOption h5 {
  width: calc(100% - 45px);
}

.menuText {
  color: #8a7ae8;
  transform: translateX(-250px);
  opacity: 0;
  transition: transform 0.3s ease 0.1s;
}

.menu .about {
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  flex-direction: column;
  font-family: sans-serif;
  opacity: 0;
  white-space: nowrap;
  transition: 0.3s ease 0.15s;
}

.open {
  width: 240px;
}
.open2 {
  opacity: 1;
  transform: translateX(-5%);
  letter-spacing: 5px;
  font-size: 18px;
}
.open1 {
  opacity: 1;
  transform: translateX(-50%);
}

.menu .menuBreak {
  width: 100%;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu .menuBreak hr {
  width: 98%;
  height: 3px;
  background-color: #8a7ae8;
  border: none;
  border-radius: 5px;
  opacity: 0.1;
}

.menu .themeBar {
  overflow: hidden;
  width: 100%;
  height: 10%;
  padding: 0.5rem;
}

.menu .themeBar div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.5rem;
  transition: 0.3s ease;
}

.menu .themeBar div button {
  background-color: transparent;
  outline: none;
  border: none;
  border-radius: 0.5rem;
  color: #8a7ae8;
  width: 100%;
  height: 45px;
  transition: 0.3s ease;
  font-size: 1rem;
}

.menu .themeBar div button:hover {
  background-color: #364152;
  color: #f19fa3;
}

.menu .menuUser {
  width: 100%;
  height: 20%;
}

.menu .menuUser a {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  padding: 0.5rem;
  position: relative;
}

.menu .menuUser a div {
  width: 45px;
  height: 45px;
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  border: #f19fa3 1px solid;
  margin: auto;
  background-color: #d1d4dc;
}

.menu .menuUser a div img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
}

.menu .menuUser a .Username {
  width: calc(70% - 45px);
}

.menu .menuUser a p {
  width: calc(30% - 45px);
}

.menu .menuUser a:hover p {
  animation: animArrow 0.3s ease 2;
  color: #f19fa3;
}

@keyframes animArrow {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(5px);
  }

  100% {
    transform: translateX(0);
  }
}

.menu .menuUser .userInfo {
  position: absolute;
  width: 20rem;
  height: 18rem;
  opacity: 0;
  pointer-events: none;
  top: 34%;
  left: 1.5rem;
  transition: 0.3s ease;
  transform: scale(0);
  transform-origin: bottom left;
}

.menu .menuUser:hover .userInfo {
  pointer-events: all;
  opacity: 1;
  transform: scale(1);
  color: #f19fa3;
}
</style>
